import {defaultContent} from "./defaultContent";

const DIRECTUS_URL = "https://directus.lmeli.com";

const COLLECTIONS = {
    concepts: "concepts",
    services: "conceptsServices",
    tours: "conceptsTours",
    gallery: "conceptsGallery",
    faq: "conceptsFAQ",
};

export const fetchCollection = async (collectionName) => {
    const endpoint = COLLECTIONS[collectionName];
    if (!endpoint) {
        throw new Error(`Invalid collection name: ${collectionName}`);
    }

    const response = await fetch(`${DIRECTUS_URL}/items/${endpoint}`);
    if (!response.ok) {
        throw new Error(`Failed to fetch ${collectionName}: ${response.statusText}`);
    }
    return response.json();
};

export const fetchAllContent = async () => {
    try {
        const fetchPromises = Object.entries(COLLECTIONS).map(([name, endpoint]) =>
            fetchCollection(name).catch((error) => {
                console.error(`Error fetching ${name}:`, error);
                return {data: null};
            }),
        );

        const results = await Promise.all(fetchPromises);

        // Create the result object dynamically
        const result = {
            ...defaultContent,
        };

        Object.entries(COLLECTIONS).forEach(([name, endpoint], index) => {
            const response = results[index];
            // Check if the response data is an array or object
            const isArray = Array.isArray(response?.data);

            if (isArray) {
                result[name] = response?.data || [];
            } else {
                // If it's not an array, it's a single object, so spread its properties
                Object.assign(result, response?.data || {});
            }
        });

        return result;
    } catch (error) {
        console.error("Error fetching all content:", error);
        return {...defaultContent};
    }
};

export const getDirectusImage = (imageUID) => {
    return imageUID ? `${DIRECTUS_URL}/assets/${imageUID}` : "/assets/placeholder.png";
};
